import Alert from "./alert";

export default class Download {
    static base64File(contentType, base64Data, fileName) {
        if(!base64Data)
            return Alert.error('Não é possível realizado o download. Contéudo do arquivo nulo.');

        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    static download(data, contentType = 'application/pdf') {
        const file = new Blob([data], {type: contentType});
        const fileURL = URL.createObjectURL(file);

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = fileURL;

        document.body.appendChild(iframe);

        iframe.onload = function () {
            iframe.contentWindow.print();
        };

        URL.revokeObjectURL(fileURL);
    }

    static downloadCSV(data, fileName = 'download.csv', contentType = 'text/csv') {
        const blob = new Blob([data], { type: contentType });
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;

        link.setAttribute('download', fileName);

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    static downloadFile(data, fileName, contentType = 'application/octet-stream') {
        const blob = new Blob([data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    }

    static openPdf(data, contentType = 'application/pdf') {
        const file = new Blob([data], { type: contentType });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_blank');

        setTimeout(() => {
            URL.revokeObjectURL(fileURL);
        }, 100);
    }
}